module.exports = __webpack_public_path__ + "static/media/DSC_0321.34b0392d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/events/DSC_0321.jpg
// module id = 595
// module chunks = 0